import { Swiper } from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Navigation, Pagination]);

export default () => {
    const nodeSelectors = {
        container: '[js-counter-slider="container"]',
        slider: '[js-counter-slider="slider"]',
        pagination: '[js-counter-slider="pagination"]',
        prev: '[js-counter-slider="prev"]',
        next: '[js-counter-slider="next"]',
        play: '[js-counter-slider-play="play-button"]',
    };

    function init() {
        const slidersContainers = document.querySelectorAll(
            nodeSelectors.container
        );

        if (!slidersContainers.length) {
            return;
        }

        initSlider(slidersContainers);
    }

    function initSlider(slidersContainers) {
        slidersContainers.forEach(function (container) {
            const sliderEl = container.querySelector(nodeSelectors.slider);

            if (!sliderEl) {
                return;
            }

            const slides = sliderEl.querySelectorAll('.swiper-slide');
            const slidesCount = slides.length;

            if (!slidesCount) {
                return;
            }

            const mobileSlidesPerView = 1;
            const smallTabletSlidesPerView = Math.min(slidesCount, 2);
            const tabletSlidesPerView = Math.min(slidesCount, 3);
            const desktopSlidesPerView = Math.min(slidesCount, 4);

            const counterSlider = new Swiper(sliderEl, {
                slidesPerView: mobileSlidesPerView,
                spaceBetween: 0,
                loop: slidesCount > 1,
                speed: 500,

                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },

                pagination: {
                    el: container.querySelector(nodeSelectors.pagination),
                    clickable: true,
                },

                breakpoints: {
                    300: {
                        slidesPerView: mobileSlidesPerView,
                    },

                    768: {
                        slidesPerView: smallTabletSlidesPerView,
                    },
                    1000: {
                        slidesPerView: tabletSlidesPerView,
                    },
                    1100: {
                        slidesPerView: desktopSlidesPerView,
                    }
                }
            });
        });
    }

    return Object.freeze({
        init,
    });
};